import { render } from "./MobileCallBar.vue?vue&type=template&id=132f6820&scoped=true&bindings={\"shop\":\"data\"}"
import script from "./MobileCallBar.vue?vue&type=script&lang=js"
export * from "./MobileCallBar.vue?vue&type=script&lang=js"

import "./MobileCallBar.vue?vue&type=style&index=0&id=132f6820&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-132f6820"

export default script